import AccordionSection from './AccordionSection.jsx';
import MediaManager from './forms/MediaManager.jsx';

export default function RebuildBasePriceForm({ formData, onFormChange, onToggleSection, openSection }) {
    
    return (
        <div className="space-y-2">
            <AccordionSection title="6. Base Machine Pricing" id="basePrice" openSection={openSection} onToggle={onToggleSection}>
                <div className="p-4">
                    <p className="text-gray-600 mb-4">Enter the base price for the machine in its current "AS-IS" condition, prior to any rebuild or upgrades.</p>
                    <div>
                        <label htmlFor="base_price" className="block text-sm font-medium text-gray-700">Base Machine Price (ZAR):*</label>
                        <div className="mt-1 relative rounded-md shadow-sm">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <span className="text-gray-500 sm:text-sm">R</span>
                            </div>
                            <input
                                type="text"
                                name="base_price"
                                id="base_price"
                                value={formData.base_price ?? ''}
                                onChange={onFormChange}
                                className="block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md shadow-sm"
                                placeholder="0.00"
                            />
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                <span className="text-gray-500 sm:text-sm">ZAR</span>
                            </div>
                        </div>
                    </div>
                    <div className="mt-4 pt-4 border-t border-gray-200">
                        <div className="relative flex items-start">
                            <div className="flex items-center h-5">
                                <input
                                    id="is_price_on_request"
                                    name="is_price_on_request"
                                    type="checkbox"
                                    checked={!!formData.is_price_on_request}
                                    onChange={onFormChange}
                                    className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                                />
                            </div>
                            <div className="ml-3 text-sm">
                                <label htmlFor="is_price_on_request" className="font-medium text-gray-700">Set Price on Request</label>
                                <p className="text-gray-500">
                                    {formData.is_price_on_request
                                        ? "This price will not be publicly shown. It will only be revealed to verified buyers who go through the Price on Request process."
                                        : "Check this box to hide the price from public view."
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                    <p className="mt-4 mb-4 text-gray-500 text-sm">This price assumes the machine is sold "AS-IS" with no rebuilds or major systems refreshed. Please upload photos of the machine in its base condition.</p>
                    
                    <MediaManager formData={formData} onFormChange={onFormChange} />
                    
                    <div className="mt-6 pt-4 border-t border-gray-200">
                        <h4 className="font-medium text-gray-900 mb-2">Spares/Components Sales</h4>
                        <p className="text-sm text-gray-600 mb-3">Are you willing to sell any parts or components from this machine separately (stripping for spares)?</p>
                        <div className="flex space-x-6">
                            <label className="inline-flex items-center cursor-pointer">
                                <input type="radio" name="willing_to_sell_spares" value="yes" checked={formData.willing_to_sell_spares === 'yes'} onChange={onFormChange} className="form-radio text-blue-600" />
                                <span className="ml-2 text-sm text-gray-700">Yes</span>
                            </label>
                            <label className="inline-flex items-center cursor-pointer">
                                <input type="radio" name="willing_to_sell_spares" value="no" checked={formData.willing_to_sell_spares === 'no'} onChange={onFormChange} className="form-radio text-blue-600" />
                                <span className="ml-2 text-sm text-gray-700">No</span>
                            </label>
                        </div>
                    </div>
                </div>
            </AccordionSection>
        </div>
    );
}
